import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CompaniesService } from '../../../../services/companies';
import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'app-ourpartners',
  templateUrl: './ourpartners.component.html',
  styleUrl: './ourpartners.component.scss'
})
export class OurpartnersComponent implements OnInit {

  partners: any[] = [];

  isLoading = false;
  errorMessage = '';

  private readonly limit = 10;

  private readonly storageRoot = environment.Server_URL
    .replace(/\/api\/?$/, '')
    .replace(/\/$/, '');

  constructor(
    private companiesService: CompaniesService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.loadPartners();
  }

  loadPartners(): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.companiesService.getAll(this.limit, 1).subscribe({
      next: (res: any) => {
        const list = Array.isArray(res)
          ? res
          : Array.isArray(res?.data)
            ? res.data
            : Array.isArray(res?.companies)
              ? res.companies
              : [];
        this.partners = list.slice(0, this.limit);
        this.isLoading = false;
      },
      error: () => {
        this.errorMessage = 'حدث خطأ أثناء تحميل الشركاء';
        this.isLoading = false;
      }
    });
  }

  getCompanyName(company: any): string {
    const currentLang = isPlatformBrowser(this.platformId)
      ? localStorage.getItem('lang') || localStorage.getItem('language') || 'en'
      : 'en';

    if (currentLang === 'ar') {
      return company?.name_ar || company?.name || 'Partner';
    }

    return company?.name || company?.name_ar || 'Partner';
  }

  getLogoUrl(company: any): string {
    const imageUrl = company?.image_url;
    const image = company?.image;

    if (imageUrl) {
      return imageUrl;
    }

    if (!image) {
      return '';
    }

    if (image.startsWith('http')) {
      return image;
    }

    const cleanImage = image.replace(/^\/+/, '');

    if (cleanImage.startsWith('storage/')) {
      return `${this.storageRoot}/${cleanImage}`;
    }

    return `${this.storageRoot}/storage/${cleanImage}`;
  }

  getInitials(company: any): string {
    const name = this.getCompanyName(company);

    return name
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((word: string) => word.charAt(0))
      .join('')
      .toUpperCase();
  }

  trackByCompany(index: number, company: any): number {
    return company?.id || index;
  }

}
